import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import RegisterBatch from './pages/RegisterBatch';
import ViewBatches from './pages/ViewBatches';
import Recall from './pages/Recall';
import Approvals from './pages/Approvals';
import Intelligence from './pages/Intelligence';
import './App.css';

const getUser = () => localStorage.getItem('verichain_user');
const getRole = () => localStorage.getItem('verichain_role') || 'operator';

// Protected route — must be logged in
const ProtectedRoute = ({ children }) => {
  return getUser() ? children : <Navigate to="/login" />;
};

// Role protected route — must be logged in AND have correct role
const RoleRoute = ({ children, allowedRole }) => {
  if (!getUser()) return <Navigate to="/login" />;
  if (getRole() !== allowedRole) return <Navigate to="/dashboard" />;
  return children;
};

function App() {
  return (
    <Router>
      <Routes>

        {/* Public */}
        <Route path="/login" element={<Login />} />

        {/* Root redirect */}
        <Route
          path="/"
          element={
            getUser()
              ? <Navigate to="/dashboard" />
              : <Navigate to="/login" />
          }
        />

        {/* All logged in users */}
        <Route path="/dashboard" element={
          <ProtectedRoute><Dashboard /></ProtectedRoute>
        } />
        <Route path="/batches" element={
          <ProtectedRoute><ViewBatches /></ProtectedRoute>
        } />
        <Route path="/intelligence" element={
          <ProtectedRoute><Intelligence /></ProtectedRoute>
        } />

        {/* Operator only */}
        <Route path="/register-batch" element={
          <RoleRoute allowedRole="operator"><RegisterBatch /></RoleRoute>
        } />
        <Route path="/recall" element={
          <RoleRoute allowedRole="operator"><Recall /></RoleRoute>
        } />

        {/* Manager only */}
        <Route path="/approvals" element={
          <RoleRoute allowedRole="manager"><Approvals /></RoleRoute>
        } />

        {/* Catch all */}
        <Route path="*" element={<Navigate to="/" />} />

      </Routes>
    </Router>
  );
}

export default App;